<template>
  <div class="container">
    <div class="cate" v-for="(cate,index) in softCates" :key="index">
      <moduleTitle :title="cate.name" />
      <div class="row">
        <div class="col-md-3" v-for="(soft,index) in cate.softs" :key="index">
          <div class="soft-item" data-aos="fade-up" data-aos-offset="0" data-aos-delay="50" data-aos-duration="500">
            <div class="title">
              <img :src="utils.getSoftIcon(soft.licenseCode)" alt />
              <span class="item-title">{{soft.name}}</span>
            </div>
            <div class="desc">{{soft.desc}}</div>
            <div class="btns row">
              <div class="col-md-12 col-12" style="margin-top: 5px;">
                <el-button
                  style="width: 100%;"
                  v-if="soft.webSite"
                  @click="openUrl(`https://${soft.licenseCode}.jiandanke.cn/#/help`)"
                  type="primary"
                  size="small"
                  icon="el-icon-document"
                >帮助中心</el-button>
                <el-button v-else style="width: 100%;" type="info" size="small" plain disabled>帮助中心</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moduleTitle from '@/components/moduleTitle'

export default {
  components: {
    moduleTitle
  },
  props: {
    list: {
      type: Array,
      default: () => {}
    }
  },
  data() {
    return {}
  },
  watch: {},
  computed: {
    ...mapGetters(['softCates'])
  },
  created() {
    this.utils.refreshSoftCates()
  },
  methods: {
    openUrl(url) {
      let newUrl = url
      if (this.onloadArgs.getInvite()) {
        newUrl = newUrl + `/#/?invite=${this.onloadArgs.getInvite()}`
      }
      window.open(newUrl, '_blank ')
    }
  }
}
</script>
<style lang="scss" scoped>
@media screen and (max-width: 576px) {
  .soft-item {
    .title {
      margin: 5px !important;
    }
  }
}

.soft-item {
  background: #fff;
  margin-bottom: 10px;
  border: 1px #eee solid;
  padding: 10px 20px 20px 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  .title {
    margin: 10px 0;
    img {
      width: 24px;
      height: 24px;
    }
    span {
      line-height: 24px;
      font-size: 16px;
      font-weight: 400;
      padding-left: 5px;
    }
  }
  .desc {
    color: #999;
    font-size: 12px;
    line-height: 18px;
    height: 36px;
    // white-space: nowrap;
    overflow: hidden; //超出的文本隐藏
    text-overflow: ellipsis; //溢出用省略号显示
  }
  .btns {
    margin: 10px 0 0 0;
    .btn {
      width: 100%;
      margin: 5px 0;
    }
  }
}

.soft-item:hover {
  // margin-top: -10px;
  border: 1px solid rgba(21, 138, 253, 0.5);
  box-shadow: 0px 0px 26px rgba(21, 138, 253, 0.25);
}
</style>